import {
  HasTenantResource,
  ResourceConfig,
  SearchFilterConfig,
} from '@hidat/huijs-resource';
import {
  FieldConfig,
  FieldDataTypes,
  nNumber,
  uNumber,
  uString,
} from '@hidat/huijs-common';
import { LocalDate, LocalTime } from '@js-joda/core';
import { SplixerResourceInterface } from './splixer-resource.interface';

export const ProgramScheduleConfig = new ResourceConfig(
  'ProgramSchedule',
  'program_schedules',
).addFields([
  new FieldConfig('stationId', FieldDataTypes.NUMBER),
  new FieldConfig('programId', FieldDataTypes.NUMBER),
  new FieldConfig('scheduleId', FieldDataTypes.NUMBER),
  new FieldConfig('hostId', FieldDataTypes.NUMBER),
  new FieldConfig('remoteCode'),
  new FieldConfig('startsAt', FieldDataTypes.DATE),
  new FieldConfig('endsAt', FieldDataTypes.DATE),
  new FieldConfig('startTime', FieldDataTypes.TIME),
  new FieldConfig('endTime', FieldDataTypes.TIME),
  new FieldConfig('duration', FieldDataTypes.INTEGER),
  new FieldConfig('monday', FieldDataTypes.BOOLEAN),
  new FieldConfig('tuesday', FieldDataTypes.BOOLEAN),
  new FieldConfig('wednesday', FieldDataTypes.BOOLEAN),
  new FieldConfig('thursday', FieldDataTypes.BOOLEAN),
  new FieldConfig('friday', FieldDataTypes.BOOLEAN),
  new FieldConfig('saturday', FieldDataTypes.BOOLEAN),
  new FieldConfig('sunday', FieldDataTypes.BOOLEAN),
]);

export const ProgramScheduleIncludes = {
  program: 'program',
  host: 'host',
  station: 'station',
};

export const ProgramScheduleFilterConfig = new SearchFilterConfig(
  ProgramScheduleConfig,
  {
    only: ['stationId', 'programId', 'hostId', 'startsAt', 'startHour'],
  },
);

export interface ProgramTimeSlotInterface
  extends SplixerResourceInterface<number>, HasTenantResource {
  stationId: uNumber;
  programId: uNumber;
  scheduleId: nNumber;
  hostId: nNumber;
  remoteCode: uString;
  startsAt: LocalDate | undefined;
  endsAt: LocalDate | undefined | null;
  startTime: LocalTime | undefined;
  endTime: LocalTime | undefined;
  // Start hour of day, 0 = midnight
  //startHour: number;
  // Start minute of hour
  //startMinute: number;
  // Duration of program, in minutes
  duration: uNumber;
  // Days of the week the program is scheduled for
  monday: boolean | undefined;
  tuesday: boolean | undefined;
  wednesday: boolean | undefined;
  thursday: boolean | undefined;
  friday: boolean | undefined;
  saturday: boolean | undefined;
  sunday: boolean | undefined;
}
